module.exports = __webpack_public_path__ + "img/图层 1495@2x.3d802c0a.png";